import type { FC } from 'react';

import LegalDocument from '@/features/legal/components/LegalDocument';
import { useChildSafetyPage } from '@/features/legal/hooks/useChildSafetyPage.hook';

const ChildSafetyPage: FC = () => {
  const { content, lastUpdated } = useChildSafetyPage();

  return <LegalDocument content={content} lastUpdated={lastUpdated} />;
};

export default ChildSafetyPage;
